// Render fragment for of — the entity's GraphQL display contract.
// Scaffolded once from the @medplum/definitions reverse projection; hand-curate
// freely to match what the view renders (this file is owned, not generated).
import { graphql } from '@eluve/graphql-fhir';

/**
 * Everything a Location view (or the generic fallback) could render.
 * Compose into queries: graphql(`query { ... ...LocationRender }`, [LocationRenderFragment]).
 * References are terminal ({ reference type display }) — expand nested
 * `resource` selections in the query when resolved targets are needed.
 */
export const LocationRenderFragment = graphql(`
  fragment LocationRender on Location @_unmask {
    resourceType
    id
    meta {
      versionId
      lastUpdated
      profile
      tag {
        system
        code
      }
      security {
        system
        code
        display
      }
    }
    modifierExtension {
      url
    }
    extension {
      url
      valueCode
    }
    identifier {
      use
      system
      value
    }
    status
    operationalStatus {
      system
      code
      display
    }
    name
    alias
    description
    mode
    type {
      text
      coding {
        system
        code
        display
      }
    }
    telecom {
      system
      value
      use
    }
    address {
      use
      type
      text
      line
      city
      district
      state
      postalCode
      country
    }
    physicalType {
      text
      coding {
        system
        code
        display
      }
    }
    position {
      longitude
      latitude
      altitude
    }
    managingOrganization {
      reference
      type
      display
    }
    partOf {
      reference
      type
      display
    }
    hoursOfOperation {
      daysOfWeek
      allDay
      openingTime
      closingTime
    }
    availabilityExceptions
    endpoint {
      reference
      type
      display
    }
  }
`);
